import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BaseHttpService } from './../../shared/services/base-http.service';
import { Company } from './../models/company';
import { Observable } from 'rxjs';
import { PaginatedResponse } from './../../shared/models/paginated.response';
import { createDataQueryModel } from '@zing/grid';

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends BaseHttpService<Company> {
  constructor(
    private http: HttpClient
  ) {
    super(http);
    this.apiDomain = environment.membershipApiUrl;
    this.endpoint = 'Companies';
  }

  /**
   * Links Company with Person instance.
   *
   * @param email of the Person which we are linking company to.
   * @param companyId Id of Company.
   */
  linkPersonWithCompany(email: string, companyId: string) {
    return this.http.put<boolean>(`${this.apiDomain}/api/${this.endpoint}/associateCompany`, { email, companyId });
  }

  searchCompaniesByName(searchTerm: string): Observable<PaginatedResponse<Company>> {
    const filter = {
      filter: `contains(name,'${searchTerm}')`,
      orderBy: 'CreatedOn desc',
      skip: 0,
      top: 20
    };
    return this.http.post<any>(`${this.apiDomain}/api/${this.endpoint}/search`, filter);
  }

  getCompanyById(companyId: string): Observable<Company> {
    return this.http.get<Company>(`${this.apiDomain}/api/${this.endpoint}/${companyId}`);
  }

  getIncentiveProgramsForCompany(companyId: string) {
    return this.http.get<any>(`${this.apiDomain}/api/v1/${this.endpoint}/${companyId}/programs`);
  }

  queryCompaniesWithJmpgSubscription(queryFilter = null): Observable<PaginatedResponse<Company>> {
    const oDataModel = createDataQueryModel(queryFilter);
    return this.http.post<PaginatedResponse<Company>>(`${this.apiDomain}/api/${this.endpoint}/agency/search`, oDataModel);
  }

  getCompanyLogo(companyId: string): Observable<Blob> {
    return this.http.get(`${this.apiDomain}/api/${this.endpoint}/${companyId}/logos`, { responseType: 'blob' });
  }

  createCompanyLogo(companyId: string, formData: FormData): Observable<string> {
    return this.http.post(`${this.getFullEndpointUrl()}/${companyId}/logos`, formData, {
      headers: new HttpHeaders({
        uploadFile: 'true'
      }),
      responseType: 'text'
    });
  }
}
